import React, {memo, useMemo, useRef, useState} from 'react'
import {Tooltip} from '@mui/material'
import QuickSearchIcon from '../../assets/icons/QuickSearchIcon'
import useShortcuts from '../../hooks/useShortcuts'
import {ShortcutsCategories, ShortcutType} from '../KeyboardShortcuts/Shortcuts.types'
import {SecritySearchShortcuts} from '../KeyboardShortcuts/ShortcutsKeymap'
import {lineToolMenuItems} from '../chartV2/chartDrawingToolbar/drawingToolMenu/lineToolMenuItems'
import {shapesToolMenuItems} from '../chartV2/chartDrawingToolbar/drawingToolMenu/shapesToolMenuItems'
import {fibonacciToolMenuItems} from '../chartV2/chartDrawingToolbar/drawingToolMenu/fibonacciTools'
import {forecastToolMenuItems} from '../chartV2/chartDrawingToolbar/drawingToolMenu/forecastToolsMenuItems'
import {patternsToolMenuItems} from '../chartV2/chartDrawingToolbar/drawingToolMenu/patternToolsMenu'
import {textToolsMenuItems} from '../chartV2/chartDrawingToolbar/drawingToolMenu/textToolsMenu'
import TrendLineIcon from '../../assets/icons/drawingTools/trendLine'
import HorizontalLineIcon from '../../assets/icons/drawingTools/horizontalLine'
import ArrowIcon from '../../assets/icons/drawingTools/arrow'
import RectangleIcon from '../../assets/icons/drawingTools/rectangle'
import EllipseIcon from '../../assets/icons/drawingTools/ellipse'
import CircleIcon from '../../assets/icons/drawingTools/circle'
import PathIcon from '../../assets/icons/drawingTools/path'
import TriangleIcon from '../../assets/icons/drawingTools/triangle'
import DisjointChannelIcon from '../../assets/icons/drawingTools/disjointChannel'
import PolyLineIcon from '../../assets/icons/drawingTools/polyLine'
import ParallelChannelIcon from '../../assets/icons/drawingTools/parallelChannel'
import FlatTopBottomIcon from '../../assets/icons/drawingTools/flatTopBottom'
import RotatedRectangleIcon from '../../assets/icons/drawingTools/rotatedRectangle'
import FibonacciIcon from '../../assets/icons/drawingTools/fibonacci'
import RayIcon from '../../assets/icons/drawingTools/ray'
import ExtendedLineIcon from '../../assets/icons/drawingTools/extendedLine'
import TrendAngleIcon from '../../assets/icons/drawingTools/trendAngle'
import InfoLineIcon from '../../assets/icons/drawingTools/infoLine'
import ForecastIcon from '../../assets/icons/drawingTools/forecast'
import PriceRangeIcon from '../../assets/icons/drawingTools/priceRange'
import FibonacciCirclesIcon from '../../assets/icons/drawingTools/fibonacciCircles'
import TextIcon from '../../assets/icons/drawingTools/text'
import XABCDPatternIcon from '../../assets/icons/drawingTools/xabcdPattern'
import ABCDPatternIcon from '../../assets/icons/drawingTools/abcdPattern'
import ZoomInIcon from '../../assets/icons/drawingTools/zoomInTool'
import PriceNoteIcon from '../../assets/icons/drawingTools/priceNote'
import AnchoredTextIcon from '../../assets/icons/drawingTools/anchoredText'
import TrendBasedFibonacciIcon from '../../assets/icons/drawingTools/trendBasedFibonacci'
import GannFanIcon from '../../assets/icons/drawingTools/gannFan'
import DateRangeIcon from '../../assets/icons/drawingTools/dateRange'
import TrianglePatternIcon from '../../assets/icons/drawingTools/trianglePattern'
import VerticalLine from '../../assets/icons/drawingTools/verticalLine'
import CrossLine from '../../assets/icons/drawingTools/crossLine'
import HorizontalRay from '../../assets/icons/drawingTools/horizontalRay'
import ThreeDivesPatternIcon from '../../assets/icons/drawingTools/3DivesPattern'
import ElliottImpulseWaveIcon from '../../assets/icons/drawingTools/elliottImpulseWave'
import HeadAndShoulderIcon from '../../assets/icons/drawingTools/headAndShoulderPattern'
import LongPositionForecastIcon from '../../assets/icons/drawingTools/longPositionForecast'
import { lazyOnOpen } from '../../util/lazyOnOpen'

const QuickSearchDialog = lazyOnOpen(() => import('./QuickSearchDialog'))
import {ExtraSmallButton} from "../custom";
import {ShortcutTooltipTitle, ShortcutKeys} from '../KeyboardShortcuts/ShortcutTooltipTitle'

export function getDrawingIcon(type: string) {
    switch (type) {
        case 'trendLine':
            return <TrendLineIcon/>
        case 'horizontalLine':
            return <HorizontalLineIcon/>
        case 'arrow':
            return <ArrowIcon/>
        case 'extendedLine':
            return <ExtendedLineIcon/>
        case 'trendAngle':
            return <TrendAngleIcon/>
        case 'infoLine':
            return <InfoLineIcon/>
        case 'ray':
            return <RayIcon/>
        case 'parallelChannel':
            return <ParallelChannelIcon/>
        case 'flatTopBottom':
            return <FlatTopBottomIcon/>
        case 'disjointChannel':
            return <DisjointChannelIcon/>
        case 'rectangle':
            return <RectangleIcon/>
        case 'ellipse':
            return <EllipseIcon/>
        case 'triangle':
            return <TriangleIcon/>
        case 'circle':
            return <CircleIcon/>
        case 'path':
            return <PathIcon/>
        case 'polyLine':
            return <PolyLineIcon/>
        case 'rotatedRectangle':
            return <RotatedRectangleIcon/>
        case 'fibonacci':
            return <FibonacciIcon/>
        case 'trendBasedFibonacci':
            return <TrendBasedFibonacciIcon/>
        case 'dateRange':
            return <DateRangeIcon/>
        case 'priceRange':
            return <PriceRangeIcon/>
        case 'forecast':
            return <ForecastIcon/>
        case 'fibonacciCircles':
            return <FibonacciCirclesIcon/>
        case 'horizontalRay':
            return <HorizontalRay/>
        case 'gannFan':
            return <GannFanIcon/>
        case 'xabcdPattern':
            return <XABCDPatternIcon/>
        case 'abcdPattern':
            return <ABCDPatternIcon/>
        case 'trianglePattern':
            return <TrianglePatternIcon/>
        case 'verticalLine':
            return <VerticalLine/>
        case 'crossLine':
            return <CrossLine/>
        case '3DivesPattern':
            return <ThreeDivesPatternIcon/>
        case 'elliottImpulseWave':
            return <ElliottImpulseWaveIcon/>
        case 'headAndShoulderPattern':
            return <HeadAndShoulderIcon/>
        case 'text':
            return <TextIcon/>
        case 'anchoredText':
            return <AnchoredTextIcon/>
        case 'priceNote':
            return <PriceNoteIcon/>
        case 'zoomIn':
            return <ZoomInIcon/>
        case 'positionForecast':
            return <LongPositionForecastIcon/>
        default:
            return null
    }
}

export const combinedDrawingToolItems = [
    ...lineToolMenuItems,
    ...shapesToolMenuItems,
    ...fibonacciToolMenuItems,
    ...forecastToolMenuItems,
    ...patternsToolMenuItems,
    ...textToolsMenuItems
]


export type QuickSearchButtonProps = {
    disabled?: boolean
}
const QuickSearchButton: React.FC<QuickSearchButtonProps> = ({disabled = false}) => {
    const [open, setOpen] = useState(false)
    const [search, setSearch] = useState('')
    const buttonRef = useRef<HTMLButtonElement | null>(null)
    const handleOpen = () => setOpen(true)
    const handleClose = () => {
        setOpen(false)
        setSearch('')
    }
    const shortcuts: ShortcutType = useMemo(() => ({
        [SecritySearchShortcuts.quickSearch]: () => {
            setOpen(true)
        }
    }), [])

    useShortcuts(ShortcutsCategories.QUICK_SEARCH, shortcuts)
    return (
        <>
            <Tooltip
                title={
                    <ShortcutTooltipTitle label="Quick Search">
                        <ShortcutKeys keys={['⌘', 'K']} />
                    </ShortcutTooltipTitle>
                }
                arrow
                placement="bottom"
            >
                <span>
                <ExtraSmallButton aria-label="Quick Search" disabled={disabled} ref={buttonRef} onClick={handleOpen} color="inherit">
                    <QuickSearchIcon/>
                </ExtraSmallButton>
                </span>
            </Tooltip>
            <QuickSearchDialog open={open} onClose={handleClose}/>
        </>
    )
}

export default memo(QuickSearchButton)
